import { useEffect, useRef, useState } from 'react'
// import { useToasts } from 'react-toast-notifications'
import SocketIOClient from '../lib/SocketIOClient'

export const useUpdateSystemVersion = () => {
  const [showAlert, setShowAlert] = useState(false)

  const socketRef = useRef(null)

  // const { addToast } = useToasts()

  const currentVersion = sessionStorage.getItem('version')

  useEffect(() => {
    if (!socketRef.current) {
      socketRef.current = new SocketIOClient()

      socketRef.current.emit('recruiter_dashboard_updates', {
        website: 'Recruiter Dashboard',
      })

      socketRef.current.on('update_recruiter_dashboard', (data) => {
        if (currentVersion !== data?.version_number) setShowAlert(true)
        // addToast(
        //   `You are currently using an outdated version of this system. To prevent any issues, Please reload this page.`,
        //   {
        //     appearance: 'info',
        //     autoDismiss: false,
        //   }
        // )

        sessionStorage.setItem('version', data.version_number)
      })
    }

    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect()
        socketRef.current = null
      }
    }
  }, [])

  return { showAlert }
}
